<template>
  <facquick-card title="Fees Discounts">
    <template v-slot:header-actions>
      <v-btn color="primary" icon class="elevation-3" @click="showD=!showD">
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <template v-slot:card-content>
      <v-data-table
        :headers="discount_headers"
        :items="discounts"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.category }}</td>
          <td class="text-xs-center">{{props.item.val_type=='percentage'?props.item.val+'%':'GHS'+props.item.val}}</td>
          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editdiscount(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs6>
                <v-btn flat icon color="pink" @click="deletediscount(props.item, props.item.index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>

      <m-dialog title="Fees Discount" :show="showD" pers>
        <template v-slot:header-actions>
          <v-btn @click="showD=!showD" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form">
           <v-text-field label="Name" v-model="discount_model.name" :rules="validRules.required"/>
           <v-autocomplete :items="['Scholarship','Bursary','Credit']" label="Discount Category" v-model="discount_model.category" :rules="validRules.required"/>
           <v-autocomplete :items="['money','percentage']" label="Disc. Value Type" v-model="discount_model.val_type" :rules="validRules.required"/>
           <v-text-field label="Discount Value (%)" v-model="discount_model.val" v-if="discount_model.val_type=='percentage'" :rules="validRules.required"/>
           <v-text-field label="Discount Value (GHS)" v-model="discount_model.val" v-if="discount_model.val_type=='money'" type="number" step="any" :rules="validRules.required"/>

          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn style="cursor:pointer" color="success" @click="savediscount()">save</v-btn>
          <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </m-dialog>
    </template>
  </facquick-card>
</template>

<script>
import { mapGetters } from "vuex";
import QuickCard from "../Quickcard";
import Mdialog from "../Modal";
export default {
  name: "additional-charges",
  components: {
    "facquick-card": QuickCard,
    "m-dialog": Mdialog
  },
  data() {
    return {
      showD: false,
      pers: false,
      search: "",
      editedIndex: -1,
      discount_model: {
        name: "",
        category: "",
        val_type: "",
        val: "",
      },
       discount_modelcp: {
        name: "",
        category: "",
        val_type: "",
        val: "",
      },
      discount_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn"
        },
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "Disc. Category",
          align: "center",
          sortable: false,
          value: "category"
        },
        {
          text: "Disc. Value",
          align: "center",
          sortable: false,
          value: "val"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("discounts/getAll");

    //console.log("discountsooooo",discounts)
  },
  computed: {
    ...mapGetters({
      discounts: "discounts/DISCOUNTS",
      dserrors: "discounts/DISCOUNT_ERROR",
      loading: "discounts/DISCOUNT_LOADING"
    })
  },
  methods: {
    adddiscount() {
      this.$store.dispatch("discounts/add", this.discount_model);

      if (this.dserrors == null) {
        this.discount_model = this.discount_modelcp;
         this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Discount saved successfully",
                title: "Fees Discount",
                modal: false
            })
      }
    },
    deletediscount(discount, index) {
      if (confirm("Are you sure you want to delete this discount? Note:All students on this discount will loose it.")) {
        this.$store.dispatch("discounts/delete", { discount, index });
          this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Discount deketed successfully",
                title: "Fees Discount",
                modal: false
            })
      }
    },

    editdiscount(discount) {
      this.editedIndex = this.discounts.indexOf(discount);
      this.discount_model = Object.assign({}, discount);

      //alert(this.editedIndex)

      this.showD = true;
    },
    updatediscount(discount, index) {
      this.$store.dispatch("discounts/update", { index, discount });

      if (this.dserrors ==null) {
        this.discount_model = this.discount_modelcp;
        this.editedIndex = -1;
        this.showD = false;
          this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Discount updated successfully",
                title: "Fees Discount",
                modal: false
            })
      }else{
          this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry discount could not be saved",
                title: "Fees Discount",
                modal: false
            })
      }

    },
    savediscount() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing discount info or saving discount info
      if (this.editedIndex > -1) {
        this.updatediscount(this.discount_model, this.editedIndex);
      } else {
        this.adddiscount();
      }
    }
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.discount_model = this.discount_modelcp;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/feesDiscounts.vue